import React from "react";
import cn from "classnames";
import { LABEL } from "../../../veriables";
import styles from "../serverAppPaymentScreens.module.scss";
import SUCCESS from '@assets/images/GIFs/SUCCESS.gif'
import PENDING from '@assets/images/GIFs/PENDING.gif'
import QUESTION from '@assets/images/GIFs/QUESTIONMARK.gif'
import ERROR from '@assets/images/GIFs/ERROR.gif'
import { ReactComponent as SearchIcon } from '@assets/images/SearchDetails.svg';
import { TouchableButton } from '@components/common/Touchable'
import PaymentConfirmationLandscape from "./PaymentConfirmationLandscape";
import PaymentConfirmationVertical from "./PaymentConfirmationVertical";

const PaymentConfirmation = (props) => {
  const {
    paymentConfirmation,
    paymentProcess,
    seat,
    serverAppTheme,
    setShowTicketDetails,
    isLandScape,
    showCheckSeat,
  } = props;
  const isPaymentPartiallyComplete =
    paymentConfirmation.isPaymentPartiallyComplete;
  const isPaymentComplete = paymentConfirmation.isPaymentComplete;
  const isPartiallyPaid = paymentConfirmation.isPartiallyPaid;
  const isPaymentFailed = paymentConfirmation.isPaymentFailed;
  const isTipPartiallyPaid = paymentConfirmation.isTipPartiallyPaid;
  const creditCardTicket = seat.paymentCheck?.tickets.filter(
    (d) => d.id === seat.paymentCheck?.creditCardTicketId,
  );
  const giftCardTicket = seat.paymentCheck?.tickets.filter(
    (d) => d.id === seat.paymentCheck?.giftCardTicketId,
  );
  const creditCardData = [
    {
      type: LABEL().PPES_CHECK,
      amount: seat?.control?.partialPaymentRequestedAmount?.toFixed(2),
    },
    {
      type: `${LABEL().PPES_AUTHORIZED} ${creditCardTicket[0]?.cardType}-${creditCardTicket[0]?.redactedCardNumber?.substr(creditCardTicket[0]?.redactedCardNumber?.length - 4)}`,
      amount: creditCardTicket[0]?.ticketAmount?.toFixed(2),
    },
    {
      type: LABEL().PPES_BALANCE_DUE,
      amount: seat?.control?.partialPaymentBalanceAmount?.toFixed(2),
    },
  ];
  const partialTipData = [
    {
      type: LABEL().PPES_CHECK,
      amount: seat?.paymentCheck?.totalAmount?.toFixed(2),
    },
    {
      type: LABEL().PPES_TIP,
      amount: seat?.paymentCheck?.tip?.tipAmount?.toFixed(2),
    },
    {
      type: LABEL().PPES_TOTAL,
      amount: seat?.control?.partialPaymentRequestedAmount?.toFixed(2),
    },
    {
      type: LABEL().PPES_AUTHORIZED,
      amount: seat?.control?.partialPaymentApprovedAmount?.toFixed(2),
    },
    {
      type: LABEL().PPES_TIP_COLLECTED,
      amount: seat?.control?.partialTipApprovedAmount?.toFixed(2),
    },
    {
      type: LABEL().PPES_UNCOLLECTED_TIP,
      amount: seat?.control?.partialTipBalanceAmount?.toFixed(2),
    },
  ];
  const paymentStatus = ({ type, amount }) => (
    <div className="col-12 px-0 d-flex">
      <div className="col-9 pl-0 pr-1 text-left">{type}</div>
      <div className="col-3 pl-1 pr-0 text-right">
        {LABEL().CURRENCY_SYMBOL} {amount}
      </div>
    </div>
  );

  let sliceTicketData =
    seat?.paymentCheck?.tickets?.length >= 3
      ? seat?.paymentCheck?.tickets.slice(0, 3)
      : seat?.paymentCheck?.tickets;

  const paymentProps = {
    // booleans
    isLandScape,
    isPaymentPartiallyComplete,
    isTipPartiallyPaid,
    isPaymentComplete,
    isPartiallyPaid,
    isPaymentFailed,

    // objects & arrays
    seat,
    giftCardTicket,
    serverAppTheme,
    paymentConfirmation,
    sliceTicketData,
    creditCardData,
    partialTipData,
    styles,

    // functions
    paymentStatus,
    setShowTicketDetails,
    paymentProcess,
    showCheckSeat,

    // helpers / constants / assets
    LABEL,
    cn,
    SUCCESS,
    PENDING,
    ERROR,
    QUESTION,
    TouchableButton,
    SearchIcon,
  };

  return (
    <>
      {React.createElement(
        isLandScape ? PaymentConfirmationLandscape : PaymentConfirmationVertical,
        paymentProps
      )}
    </>
  );
};

export default PaymentConfirmation;
